import {AbstractControl, ValidationErrors} from '@angular/forms';

export function ipAddressValidator(control: AbstractControl): ValidationErrors | null {
   console.log('ipAddressValidator', control);
    if (control.value) {

      const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      const ipAddress = control.value;

      if (!regex.test(ipAddress)) {
        return { invalidIpAddress: true };
      }
    }

    return null;
}

